import { render, staticRenderFns } from "./CreateTendersView.vue?vue&type=template&id=08c9aca6&"
import script from "./CreateTendersView.vue?vue&type=script&lang=js&"
export * from "./CreateTendersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports